exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".place[data-v-fc263746]{color:#000;text-decoration:none;border-bottom:1px dotted #000}.place[data-v-fc263746]:hover{padding-bottom:1px;color:#000;border-bottom:none}.link[data-v-fc263746]{word-break:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fc263746","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/sidebar/components/LinkElement.vue
// module id = c8f505492a6398b723e8
// module chunks = 0